export default function isAdFinale(adEngageEnabled, config = {}, results = [], resultIndex = 0) {
  const hasFinish = resultIndex === results.length - 1;
  const { rootbeer } = config;
  const { placement } = rootbeer || {};

  return adEngageEnabled && hasFinish && rootbeer && placement === "end";
}
